import * as R from 'ramda';
export const isTrue = R.equals(true);
export const isFalse = R.equals(false);
export const anyTrue = R.any(isTrue);
export const allTrue = R.all(isTrue);
export const isNot = R.complement(R.is);
export const notEquals = R.complement(R.equals);
export const hasAny = R.curry((props, val) => R.pipe(R.map(R.has), R.anyPass, R.apply(R.__, [val]))(props));
